<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline mb-4">{{ $t('investorAutos.title') }}</h1>
          <div
            v-if="dataIsLoading"
            class="progress d-flex justify-center align-center mt-4"
          >
            <v-progress-circular :size="70" color="warning" indeterminate />
          </div>
          <!-- Investor autos table -->
          <v-layout wrap align-center v-if="!dataIsLoading">
            <v-flex xs12>
              <v-data-table
                id="investorAutos"
                :items="investorAutos.items"
                :headers="headers"
                :loading="isLoading"
                :loading-text="$t('common.table.dataIsLoading')"
                :server-items-length="2"
                :mobile-breakpoint="100"
                class="table-custom investorAutos small mb-4"
                hide-default-footer
              >
                <template slot="item" slot-scope="{ item }">
                  <tr @click="goToAutoPage(item.id)">
                    <td class="text-xs-left">{{ item.num }}</td>
                    <td class="text-xs-left">{{ item.number }}</td>
                    <td class="text-xs-left">{{ item.brand }}</td>
                    <td class="text-xs-left details">{{ item.model }}</td>
                    <td class="text-xs-left">{{ item.year }}</td>
                    <td class="text-xs-left">{{ item.company }}</td>
                  </tr>
                </template>
                <template slot="no-data">{{
                  $t('common.table.noData')
                }}</template>
              </v-data-table>
              <div v-if="paginationPage" class="text-xs-center">
                <v-pagination
                  :value="paginationPage"
                  :length="paginationLength"
                  @input="choosePaginatorPage($event)"
                ></v-pagination>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'InvestorAutosPage',
  components: {},
  data() {
    return {
      dataIsLoading: false,
      headers: [
        { text: this.$t('common.number'), sortable: false },
        { text: this.$t('investorAutos.tableHeaders.number'), sortable: false },
        { text: this.$t('investorAutos.tableHeaders.brand'), sortable: false },
        { text: this.$t('investorAutos.tableHeaders.model'), sortable: false },
        { text: this.$t('investorAutos.tableHeaders.year'), sortable: false },
        {
          text: this.$t('investorAutos.tableHeaders.company'),
          sortable: false,
        },
      ],
    };
  },
  watch: {
    /* eslint-disable */
    '$i18n.locale': async function() {
      await this.fetchInvestorAutos({
        page: this.paginationPage,
        investorId: this.$route.params.investorId,
      });
      this.$vuetify.goTo(0, 'easeInOutCubic');
    },
  },
  computed: {
    ...mapGetters({
      isLoading: 'global/getLoader',
      investorAutos: 'investor/getInvestorAutosData',
    }),
    paginationLength() {
      return this.investorAutos.lastPage;
    },
    paginationPage() {
      if (
        this.investorAutos.currentPage === 1 &&
        this.investorAutos.lastPage === 1
      ) {
        return 0;
      }
      return this.investorAutos.currentPage;
    },
  },
  async created() {
    this.dataIsLoading = true;
    try {
      await this.fetchInvestorAutos({
        page: 1,
        investorId: this.$route.params.investorId,
      });
      this.dataIsLoading = false;
    } catch (error) {
      if (error.status === 404) {
        this.$router.push({ name: 'not-found' });
        return;
      }
      this.dataIsLoading = false;
    }
  },
  destroyed() {
    this.clearAlertError();
    this.setInvestorAutosData({});
  },
  methods: {
    ...mapActions({
      fetchInvestorAutos: 'investor/fetchInvestorAutosData',
    }),
    ...mapMutations({
      clearAlertError: 'global/clearAlertError',
      setInvestorAutosData: 'investor/setInvestorAutosData',
    }),
    async choosePaginatorPage(page) {
      await this.fetchInvestorAutos({
        page,
        investorId: this.$route.params.investorId,
      });
      this.$vuetify.goTo(0, 'easeInOutCubic');
    },
    goToAutoPage(autoId) {
      this.$router.push(`/autos/${autoId}/info`);
    },
  },
};
</script>

<style lang="scss" scoped></style>
